import React, { useState, useEffect } from "react";
import MainToolbar from "../MainToolbar";
import {
  TableContainer,
  Table,
  TableRow,
  TableCell,
  TableHead,
  TableBody,
  makeStyles,
  IconButton,
  Paper,
  Button,
} from "@material-ui/core";
import t from "../common/localization";
import { useEffectAsync } from "../reactHelper";
import EditCollectionView from "../EditCollectionView";
import EditIcon from "@material-ui/icons/Edit";
import ClearIcon from "@material-ui/icons/Clear";
import { green, blue, red, grey } from "@material-ui/core/colors";
import Avatar from "@material-ui/core/Avatar";
import { showLoaderStateActions } from "./../store";
import { useDispatch, useSelector } from "react-redux";
import { DataGrid } from "@material-ui/data-grid";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

const useStyles = makeStyles((theme) => ({
  columnAction: {
    width: theme.spacing(1),
    padding: theme.spacing(0, 1),
  },
  tableAction: {
    backgroundColor: "white",
  },
  rowAction: {
    backgroundColor: "#361DDB",
  },
  iconButtons: {
    display: "flex",
    margin: theme.spacing(0.5),
  },
  small: {
    width: theme.spacing(4),
    height: theme.spacing(4),
    backgroundColor: "#EFEFEF",
    margin: "2px",
  },
  tableRow: {
    "&$hover:hover": {
      backgroundColor: "#FFFFFF",
    },
  },
}));

const GeoFenceView = ({
  updateTimestamp,
  onMenuClick,
  handleOnEdit, 
  handleOnRemove,
}) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const [successDialogShow, setSuccessDialogShow] = useState(false);

  const [items, setItems] = useState([]);

  const history = useHistory();

  // const handleOnEdit = (id) => {
  //   history.push(`/geofence/${id}`);
  // };

  // const handleOnRemove = async (id) => {
  //   if (window.confirm("Are you sure you want to delete this geofence?")) {
  //     try {
  //       dispatch(showLoaderStateActions.addState(true));

  //       const response = await fetch(`/api/geofences/${id}`, {
  //         method: "DELETE",
  //       });

  //       dispatch(showLoaderStateActions.addState(false));

  //       if (response.ok) {
  //         setItems((prevItems) => prevItems.filter((item) => item.id !== id));
  //         alert("Geofence deleted successfully.");
  //       } else {
  //         const error = await response.text();
  //         alert(`Failed to delete geofence: ${error}`);
  //       }
  //     } catch (error) {
  //       dispatch(showLoaderStateActions.addState(false));
  //       console.error("Delete error:", error);
  //       alert("An error occurred while deleting the geofence.");
  //     }
  //   }
  // };

  const columns = [
    { field: "name", headerName: t("sharedName"), flex: 1 },
    { field: "description", headerName: "Description", flex: 1 },
    {
      field: "action",
      headerName: "Action",
      flex: 1,
      sortable: false,
      renderCell: (params) => (
        <div style={{ display: "flex" }}>
          <Avatar style={{ width: 30, height: 30, backgroundColor: "#EFEFEF", margin: "2px" }}>
            <IconButton onClick={() => handleOnEdit(params.row.id)}>
              <EditIcon fontSize="small" style={{ color: blue[600] }} />
            </IconButton>
          </Avatar>
          <Avatar style={{ width: 30, height: 30, backgroundColor: "#EFEFEF", margin: "2px" }}>
            <IconButton onClick={() => handleOnRemove(params.row.id)}>
              <ClearIcon fontSize="small" style={{ color: grey[450] }} />
            </IconButton>
          </Avatar>
        </div>
      ),
    },
  ];

  const gridRows = items.map((item, index) => ({
    id: index, // required unique id for DataGrid
    name: item.name,
    description: item.description,
    action: item.id,
  }));  

  useEffectAsync(async () => {
    dispatch(showLoaderStateActions.addState(true));

    const response = await fetch("/api/geofences");
    dispatch(showLoaderStateActions.addState(false));
    if (response.ok) {
      const geoFenceData = await response.json();
      setItems(geoFenceData);
    }
  }, [updateTimestamp]);

  return (
    <>
      {/* <TableContainer component={Paper}>
        <Table className={classes.tableAction} size="small">
          <TableHead>
            <TableRow className={classes.rowAction}>
              <TableCell style={{ color: "white" }}>{t("sharedName")}</TableCell>
              <TableCell style={{ color: "white" }}>{"Description"}</TableCell>
              <TableCell style={{ color: "white" }}>{"Type"}</TableCell>
              <TableCell className={classes.columnAction} />
            </TableRow>
          </TableHead>
          <TableBody>
            {items.map((item) => (
              <TableRow hover key={item.id} className={classes.tableRow}>
                <TableCell>
                  <b>{item.name}</b>
                </TableCell>
                <TableCell>{item.description}</TableCell>
                <TableCell>{item.description}</TableCell>
                <TableCell className={classes.columnAction}>
                  <div className={classes.iconButtons}>
                    <Avatar className={classes.small}>
                      <IconButton onClick={(event) => handleOnEdit(item.id)}>
                        <EditIcon fontSize="small" style={{ color: blue[600] }} />
                      </IconButton>
                    </Avatar>
                    <Avatar className={classes.small}>
                      <IconButton onClick={(event) => handleOnRemove(item.id)}>
                        <ClearIcon fontSize="small" style={{ color: grey[450] }} />
                      </IconButton>
                    </Avatar>
                  </div>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer> */}
     

      <DataGrid
        rows={items}
        columns={columns}
        pageSize={50}
        rowsPerPageOptions={[50, 100, 500]}
        style={{ height: "85vh", width: "100%", backgroundColor: "white" }}
        autoHeight={false}
        pagination
        disableSelectionOnClick
      />
    </>
  );
};

const GeoFencePage = () => {
  return (
    <>
      <MainToolbar />
      <EditCollectionView
        content={GeoFenceView}
        editPath="/geofence"
        endpoint="geofences"
        successDialogShow={false}
        style={{ height: "85vh", width: "100%", backgroundColor: "white" }}
      />
    </>
  );
};

export default GeoFencePage;
